import React from 'react';
import { Switch } from 'ui/common/switch/switch';
import { LinkCodesTranslation } from '../constants';
import { useDetailsCallbacks } from '../hooks';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';

interface ListHeaderSwitchProps {
  className: string;
  hasChanges: boolean;
  includeInactive: boolean;
  translation: LinkCodesTranslation;
}

export const ListHeaderSwitch: React.FC<ListHeaderSwitchProps> = ({
  className, hasChanges, includeInactive, translation
}) => {

  const toasts = toastFactory();
  const { updateIncludeInactive } = useDetailsCallbacks();

  const onChange = (enabled: boolean) => {

    if(hasChanges) {
      toasts.dispatchInfo(translation.message_limit_visibility);
      return;
    }

    updateIncludeInactive(enabled);
  };

  return <>
    {translation.show_inactive_codes}
    <Switch
      className={className}
      checked={includeInactive}
      onChange={onChange} />
  </>;
};
